/* The Band — Quick start guide: one scrubbed timeline across the 520vh pin (5 steps). */
(function () {
  function syncColour(root, c) {
    if (!c) return;
    root.querySelectorAll('[data-band-stack] img').forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-key') === c.key); });
  }
  function vis(el, on) { if (el) { el.style.opacity = on ? '1' : '0'; el.style.visibility = on ? 'visible' : 'hidden'; } }

  /* Reduced motion: no pin, show each step's final state. */
  function staticState(root) {
    root.classList.add('is-static');
    var one = function (s) { return root.querySelector(s); };
    var pct = one('[data-pct]'); if (pct) pct.textContent = '100';
    var led = one('[data-led]'); if (led) { led.style.backgroundColor = '#2F6FDB'; led.style.boxShadow = '0 0 0 6px rgba(47,111,219,.18)'; }
    vis(one('[data-led-a]'), false); vis(one('[data-led-b]'), true);
    vis(one('[data-pair-a]'), false); vis(one('[data-pair-b]'), true);
    vis(one('[data-t1]'), false); vis(one('[data-t2]'), true);
    var ring = one('[data-timer-ring]'); if (ring) ring.style.setProperty('--p', '100');
    var wb = one('[data-wear-band]'); if (wb) wb.style.transform = 'rotate(-2deg)';
  }

  function init(root) {
    if (!root || root._bdQs) return;
    root._bdQs = true;
    var D = window.Dozzee;
    syncColour(root, D.getColour());
    var onC = function (e) { if (document.body.contains(root)) syncColour(root, e.detail && e.detail.colour); else document.removeEventListener('dozzee:colour', onC); };
    document.addEventListener('dozzee:colour', onC);

    if (D.reduce) { staticState(root); return; }

    D.gsap(function (gsap) {
      if (!document.body.contains(root)) return;
      var q = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
      var one = function (s) { return root.querySelector(s); };
      root._bdCtx = gsap.context(function () {
        var gWrap = root.matches('[data-guide-wrap]') ? root : one('[data-guide-wrap]');
        if (!gWrap) return;
        var gv = q('[data-gv]'), gt = q('[data-gt]'), gl = q('[data-gl]'), N = gv.length, gbar = one('[data-gbar]');
        var tg = gsap.timeline({ scrollTrigger: { trigger: gWrap, start: 'top top', end: 'bottom bottom', scrub: 0.6 } });
        if (gbar) tg.fromTo(gbar, { scaleY: 0 }, { scaleY: 1, ease: 'none', duration: N }, 0);
        for (var i = 1; i < N; i++) {
          tg.to(gv[i - 1], { autoAlpha: 0, y: -30, duration: 0.22, ease: 'power1.in' }, i - 0.12)
            .fromTo(gv[i], { autoAlpha: 0, y: 40 }, { autoAlpha: 1, y: 0, duration: 0.3, ease: 'power2.out' }, i)
            .to(gt[i - 1], { autoAlpha: 0, y: -14, duration: 0.18 }, i - 0.12)
            .fromTo(gt[i], { autoAlpha: 0, y: 14 }, { autoAlpha: 1, y: 0, duration: 0.24 }, i + 0.02);
          if (gl[i]) tg.to(gl[i - 1], { opacity: 0.35, duration: 0.2 }, i - 0.1).to(gl[i], { opacity: 1, duration: 0.2 }, i - 0.1);
        }
        var pct = one('[data-pct]'), po = { v: 0 };
        tg.fromTo(one('[data-batt]'), { scaleX: 0.06 }, { scaleX: 1, ease: 'none', duration: 0.66 }, 0.04)
          .to(po, { v: 100, ease: 'none', duration: 0.66, onUpdate: function () { if (pct) pct.textContent = Math.round(po.v); } }, 0.04)
          .to(one('[data-led]'), { backgroundColor: '#2F6FDB', boxShadow: '0 0 0 6px rgba(47,111,219,.18)', duration: 0.06 }, 0.7)
          .to(one('[data-led-a]'), { autoAlpha: 0, duration: 0.04 }, 0.7).to(one('[data-led-b]'), { autoAlpha: 1, duration: 0.04 }, 0.72)
          .to(one('[data-pair-a]'), { autoAlpha: 0, duration: 0.05 }, 1.5).to(one('[data-pair-b]'), { autoAlpha: 1, duration: 0.05 }, 1.52)
          .fromTo(one('[data-pair-ok]'), { scale: 0 }, { scale: 1, duration: 0.12, ease: 'back.out(2)' }, 1.52)
          .fromTo(one('[data-wear-band]'), { rotation: -9, scale: 0.9 }, { rotation: -2, scale: 1, duration: 0.5, ease: 'power2.out' }, 2)
          .from(q('[data-wear-pin]'), { scale: 0, autoAlpha: 0, stagger: 0.12, duration: 0.14, ease: 'back.out(2)' }, 2.2);
        var ring = one('[data-timer-ring]');
        if (ring) { gsap.set(ring, { '--p': 0 }); tg.to(ring, { '--p': 50, ease: 'none', duration: 0.3 }, 3.1).to(ring, { '--p': 100, ease: 'none', duration: 0.3 }, 3.48); }
        var mn = one('[data-minus]');
        if (mn) tg.to(mn, { scale: 0.84, duration: 0.03, yoyo: true, repeat: 3 }, 3.02).to(mn, { scale: 0.84, duration: 0.03, yoyo: true, repeat: 3 }, 3.4);
        tg.to(one('[data-t1]'), { autoAlpha: 0, duration: 0.04 }, 3.44).to(one('[data-t2]'), { autoAlpha: 1, duration: 0.04 }, 3.46)
          .from(q('[data-care]'), { y: 26, autoAlpha: 0, stagger: 0.06, duration: 0.18 }, 4.04).to({}, { duration: 0.35 });
        var spin = one('[data-spin]'); if (spin) gsap.to(spin, { rotation: 360, repeat: -1, duration: 0.9, ease: 'none' });
      }, root);
    });
  }

  function boot(scope) {
    if (!window.Dozzee || !window.Dozzee.getColour) return setTimeout(function () { boot(scope); }, 50);
    (scope || document).querySelectorAll('[data-section-type="band-quickstart"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('[data-section-type="band-quickstart"]');
    if (r && r._bdCtx) r._bdCtx.revert();
  });
})();
